import { useCallback, useEffect, useState } from 'react'
import uiStates, {
  UiStateKey,
  UiStateScope,
} from '../../../../lib/commons/uiStates'

type TimeFormatState = {
  showTimeFormat: boolean
}

export const useTimeFormatState = () => {
  const [showTimeFormat, setShowTimeFormat] = useState<boolean>(true)
  const [initialized, setInitialized] = useState(false)

  const storeTimeFormatState = useCallback(async (value: boolean) => {
    await uiStates.update(
      {
        key: UiStateKey.TaskActualWorkDialogTimeFormat,
        scope: UiStateScope.User,
        value: JSON.stringify({ showTimeFormat: value }),
      },
      undefined
    )
  }, [])

  const restoreTimeFormatState = useCallback(async () => {
    try {
      const response = await uiStates.get({
        key: UiStateKey.TaskActualWorkDialogTimeFormat,
        scope: UiStateScope.User,
      })
      const stored = response.json
      if (stored.value) {
        const state: TimeFormatState = JSON.parse(stored.value)
        if (state.showTimeFormat !== undefined) {
          setShowTimeFormat(state.showTimeFormat)
        }
      }
    } finally {
      setInitialized(true)
    }
  }, [])

  useEffect(() => {
    restoreTimeFormatState()
  }, [restoreTimeFormatState])

  useEffect(() => {
    if (initialized) {
      storeTimeFormatState(showTimeFormat)
    }
  }, [initialized, showTimeFormat, storeTimeFormatState])

  const toggleTimeFormat = useCallback(() => {
    setShowTimeFormat(prev => !prev)
  }, [])

  return {
    showTimeFormat,
    setShowTimeFormat,
    toggleTimeFormat,
    initialized,
  }
}
